import NavegacionCorte from './NavegacionCorte';
export default NavegacionCorte;